import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  assignInternalPath,
  isValidInternalPath,
  replaceInternalPath,
} from '../utils/safeUrl';

/**
 * Redirect via React Router; validated same-origin fallback only if navigate throws.
 */
const SafeRedirect = ({ to, replace = false }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isValidInternalPath(to)) {
      console.error('SafeRedirect: Invalid internal path:', to);
      return;
    }

    try {
      navigate(to, { replace });
    } catch (error) {
      console.error('Navigation error:', error);
      if (replace) {
        replaceInternalPath(to);
      } else {
        assignInternalPath(to);
      }
    }
  }, [navigate, to, replace]);

  return null;
};

export default SafeRedirect;
